"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInsightArticle = void 0;
const InsightArticle_1 = require("../entity/InsightArticle");
const createInsightArticle = ({ id = 'test', url = 'test', title = 'test', thumbnailImageUrl = 'test', } = {}) => InsightArticle_1.default.fromJSON({
    id,
    url,
    title,
    thumbnailImageUrl,
});
exports.createInsightArticle = createInsightArticle;
